import TrackingBase from './TrackingBase'
import Mixpanel from 'mixpanel-browser'

class TrackingMixpanel extends TrackingBase {
  /**
   * @returns {object}
   */
  getAnalytics () {
    return window.mixpanel
  }

  /**
   */
  loadScript () {
    if (window.mixpanel) {
      this.log('Mixpanel script already loaded.')
    } else {
      Mixpanel.init(this.id)
      window.mixpanel = Mixpanel
    }
  }

  /**
   * @param {object} payload
   * @param {string} payload.event
   * @param {string} payload.object
   * @param {string} payload.category
   * @param {string} payload.action
   * @param {string} payload.label
   * @param {string} payload.value
   * @param {string} payload.item
   * @param {object} rest
   */
  trackEvent ({
    event = 'Unnamed Event',
    object = null,
    category = null,
    action = null,
    label = null,
    value = null,
    item = null,
    ...rest
  } = {}) {
    const fixedItem = this.getItemAdditionalInfo(item)

    super.trackEvent({
      event,
      object,
      category,
      action,
      label,
      value,
      item,
      fixedItem,
      ...rest
    })

    if (this.isEnabled()) {
      this.getAnalytics().track(event, {
        category,
        action,
        label,
        value,
        item: fixedItem,
        'actual-item': item,
        ...rest
      })
    }
  }

  /**
   * @param {string} userIdentifier
   * @param {object} user
   */
  identifyUser (userIdentifier, user) {
    const { email, id } = user
    const analytics = this.getAnalytics()

    super.identifyUser(userIdentifier, user)

    if (this.isEnabled() && email && id && userIdentifier && analytics) {
      analytics.identify(email)
    }
  }
}

export default TrackingMixpanel
